import { render } from "./AutenticacaoLayout.vue?vue&type=template&id=e392d7e8&ts=true"
import script from "./AutenticacaoLayout.vue?vue&type=script&lang=ts"
export * from "./AutenticacaoLayout.vue?vue&type=script&lang=ts"

import "./AutenticacaoLayout.vue?vue&type=style&index=0&id=e392d7e8&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__